import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { guestLookup } from '../api/orders';

function formatPrice(cents) {
  return '$' + (cents / 100).toFixed(2);
}

export default function OrderLookup() {
  const [form, setForm] = useState({ email: '', order_number: '' });
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setOrder(null);
    setLoading(true);
    try {
      const res = await guestLookup(form);
      setOrder(res.data);
    } catch {
      setError('Order not found. Check your email and order number.');
    }
    setLoading(false);
  };

  return (
    <div className="container section" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <p className="mono" style={{ color: 'var(--gold)', marginBottom: '8px' }}>GUEST ORDER</p>
        <h1>Track Your Order</h1>
        <p style={{ color: 'var(--warm-gray)', marginTop: '8px' }}>
          Enter your email and order number to view your order status.
        </p>
      </div>

      {!order && (
        <div className="cart-summary">
          {error && <p className="form-error" style={{ marginBottom: '16px' }}>{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required placeholder="your@email.com" />
            </div>
            <div className="form-group">
              <label className="form-label">Order Number</label>
              <input className="form-input" value={form.order_number} onChange={e => setForm(f => ({ ...f, order_number: e.target.value }))} required placeholder="FMB-00001" />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%' }}>
              {loading ? 'Looking up...' : 'Find Order'}
            </button>
          </form>
          <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '0.85rem', color: 'var(--warm-gray)' }}>
            Have an account? <Link to="/login" style={{ color: 'var(--forest)', fontWeight: '600' }}>Sign in</Link> to see all your orders.
          </p>
        </div>
      )}

      {order && (
        <>
          <div className="cart-summary">
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
              <div>
                <span className="mono" style={{ color: 'var(--warm-gray)' }}>Order Number</span>
                <p style={{ fontWeight: '700', fontSize: '1.1rem' }}>{order.order_number}</p>
              </div>
              <div>
                <span className="mono" style={{ color: 'var(--warm-gray)' }}>Date</span>
                <p>{new Date(order.created_at).toLocaleDateString()}</p>
              </div>
              <div>
                <span className="mono" style={{ color: 'var(--warm-gray)' }}>Status</span>
                <p><span className={`badge badge-${order.status}`}>{order.status}</span></p>
              </div>
            </div>

            {order.tracking_number && (
              <div style={{ background: 'var(--cream)', padding: '12px 16px', borderRadius: '6px', marginBottom: '16px' }}>
                <span className="mono" style={{ color: 'var(--warm-gray)' }}>Tracking Number</span>
                <p style={{ fontWeight: '600', marginTop: '4px' }}>{order.tracking_number}</p>
              </div>
            )}

            {order.shipping_address && (
              <div style={{ marginBottom: '16px' }}>
                <span className="mono" style={{ color: 'var(--warm-gray)' }}>Ship To</span>
                <p style={{ marginTop: '4px' }}>
                  {order.shipping_address.name}<br />
                  {order.shipping_address.line1}<br />
                  {order.shipping_address.line2 && <>{order.shipping_address.line2}<br /></>}
                  {order.shipping_address.city}, {order.shipping_address.state} {order.shipping_address.zip}
                </p>
              </div>
            )}

            <div style={{ borderTop: '1px solid var(--light-gray)', paddingTop: '16px' }}>
              {order.items?.map((item, i) => (
                <div className="cart-item" key={i}>
                  <div className="cart-item-details">
                    <div className="cart-item-name">{item.product_name}</div>
                    {(item.variant || item.color) && <div className="cart-item-variant">{item.variant || item.color}</div>}
                    <div className="cart-item-variant">Qty: {item.quantity}</div>
                  </div>
                  <div className="cart-item-price">{formatPrice(item.price_cents * item.quantity)}</div>
                </div>
              ))}
            </div>

            <div className="cart-totals">
              <div className="cart-total-row"><span>Subtotal</span><span>{formatPrice(order.subtotal_cents)}</span></div>
              <div className="cart-total-row">
                <span>Shipping</span>
                <span>{order.shipping_cents === 0 ? 'FREE' : formatPrice(order.shipping_cents)}</span>
              </div>
              <div className="cart-total-row grand"><span>Total</span><span>{formatPrice(order.total_cents)}</span></div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '24px' }}>
            <button className="btn btn-secondary" onClick={() => setOrder(null)}>Look Up Another</button>
            <Link to="/register" className="btn btn-primary">Create an Account</Link>
          </div>
        </>
      )}
    </div>
  );
}
